module.exports = (__webpack_require__(2))(25);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/FileModel.js from dll-reference girder_plugin_slicer_cli_web
// module id = 84
// module chunks = 0